import React from "react";

const Select = ({
  label,
  helper,
  error,
  className = "",
  containerClassName = "",
  children,
  ...props
}) => {
  return (
    <label
      className={[
        "flex min-w-0 flex-col gap-2 text-sm text-slate-600",
        containerClassName,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      {label}
      <select
        className={[
          "h-11 w-full min-w-0 rounded-lg border px-4 pr-10 text-base text-slate-900 shadow-sm",
          "outline-none transition appearance-none bg-white",
          "bg-[url('data:image/svg+xml;charset=UTF-8,%3csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2020%2020%22%20fill%3D%22none%22%3E%3cpath%20d%3D%22M7%207l3%203%203-3%22%20stroke%3D%22%239CA3AF%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3c%2Fsvg%3E')]",
          "bg-[length:1.5em] bg-[right_0.5rem_center] bg-no-repeat",
          error
            ? "border-rose-300 focus:border-rose-400"
            : "border-slate-200 focus:border-slate-400",
          className,
        ]
          .filter(Boolean)
          .join(" ")}
        {...props}
      >
        {children}
      </select>
      {helper && !error && (
        <span className="text-xs text-slate-500">{helper}</span>
      )}
      {error && <span className="text-xs text-rose-600">{error}</span>}
    </label>
  );
};

export default Select;
